import { Component, OnInit, OnDestroy } from '@angular/core';
import { NetworkStatusService } from '@app/core/services/network-status.service';
import { AppService, ApplicationMode } from '@app/core/services/app.service';
import { Router } from '@angular/router';
import { ChangeLogService, Subscription } from '@app/core/services/change-log.service';
import { BroadcastChannel } from 'broadcast-channel';
import { Subscription as RxSubscription } from 'rxjs';
@Component({
  selector: 'app-offline-toolbar',
  templateUrl: './offline-toolbar.component.html',
  styleUrls: ['./offline-toolbar.component.scss'],
  standalone: false,
})
export class OfflineToolbarComponent implements OnInit, OnDestroy {
  online = true;
  offlineChanges = 0;
  syncChannel: BroadcastChannel;
  changeSubscription: Subscription;
  subscriptions: RxSubscription;

  constructor(
    private networkStatusService: NetworkStatusService,
    private changeLogServices: ChangeLogService,
    private appService: AppService,
    private router: Router,
  ) {
    this.syncChannel = new BroadcastChannel('dwo-sync');
    this.subscriptions = new RxSubscription();
  }

  async ngOnInit(): Promise<void> {
    this.subscriptions.add(
      this.networkStatusService.isOnline().subscribe((online) => {
        this.online = online;
      }),
    );

    this.syncChannel.addEventListener('message', this.onSyncMessage.bind(this));

    this.changeSubscription = this.changeLogServices.subscribeAll(async () => {
      await this.fetchPendingCount();
    });

    await this.fetchPendingCount();
  }

  ngOnDestroy(): void {
    this.syncChannel.removeEventListener('message', this.onSyncMessage);
    this.changeSubscription.dispose();
    this.subscriptions.unsubscribe();
  }

  onSyncMessage() {
    this.fetchPendingCount();
  }

  async fetchPendingCount() {
    this.offlineChanges = await this.changeLogServices.getPendingCount();
  }

  switchToOnline() {
    this.appService.setMode(ApplicationMode.ONLINE);
    this.router.navigateByUrl('/');
  }
}
